const displayModesEnum = {
  PRODUCTS: 'PRODUCTS',
  PAGE: 'PAGE',
  PRODUCTS_AND_PAGE: 'PRODUCTS_AND_PAGE',
};

export default displayModesEnum;
